export const skillData = [
  {
    name: "Javascript",
    percentage: 80,
    color: "rgb(241, 252, 79)",
  },
  {
    name: "Css",
    percentage: 90,
    color: "tomato",
  },
  {
    name: "HTML",
    percentage: 92,
    color: "orange",
  },
  {
    name: "React",
    percentage: 84,
    color: "skyblue",
  },

  {
    name: "Nodejs",
    percentage: 80,
    color: "green",
  },
];
